import Alpine from "alpinejs";

/**
 * Toggle the class passed as expression for all children of the parent with the same data-id attribute value.
 * @param el Element with the attribute
 * @param expression Class to add/remove on mouse enter/mouse leave
 * @param cleanup Function used to remove event handler
 */
const hoverSibling: Alpine.DirectiveCallback = (
  el,
  { expression },
  { cleanup }
) => {
  const id = el.getAttribute("data-id");
  if (id === null) return;

  function getSiblingWithSameId(): Element[] {
    const p = el.parentElement;
    if (p === null) return [];

    return Array.from(p.querySelectorAll(`[data-id="${id}"]`));
  }

  function onMouseEnter() {
    for (let el of getSiblingWithSameId()) {
      el.classList.add(expression);
    }
  }

  function onMouseLeave() {
    for (let el of getSiblingWithSameId()) {
      el.classList.remove(expression);
    }
  }

  el.addEventListener("mouseenter", onMouseEnter);
  el.addEventListener("mouseleave", onMouseLeave);

  cleanup(() => {
    el.removeEventListener("mouseenter", onMouseEnter);
    el.removeEventListener("mouseleave", onMouseLeave);
  });
};
export default hoverSibling;
